import { ChatGateway } from './chat-gateway.interface';

const baseUrl = 'gk/chats';
export class HttpChatGateway implements ChatGateway {
  getChatByProject(args: { projectId: string; groupName: string }) {
    return {
      url: `${baseUrl}/${args.projectId}`,
      method: 'GET',
      params: { groupName: args.groupName },
    };
  }

  postMessage(args: { projectId: string; data: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/post-message`,
      method: 'POST',
      data: args.data,
    };
  }

  deleteMessage(args: { chatMessageId: string }) {
    return {
      url: `${baseUrl}/${args.chatMessageId}/messages`,
      method: 'DELETE',
    };
  }

  getDocument(args: { chatMessageId: string }) {
    return {
      url: `${baseUrl}/${args.chatMessageId}/get-document`,
      method: 'GET',
    };
  }
}
